// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2b7514db","648":"c3234726","977":"57608781"}[chunkId] + ".chunk.js";
};